export const numberFormat = (num: any, minDigits = 2, maxDigits = 2) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });
  return formatter.format(num);
};

export const toBuddhistYear = (moment: any, format: string) => {
  const christianYear = moment.format("YYYY");
  const buddhishYear = (parseInt(christianYear) + 543).toString();
  return moment
    .format(
      format
        .replace("YYYY", buddhishYear)
        .replace("YY", buddhishYear.substring(2, 4))
    )
    .replace(christianYear, buddhishYear);
};

export const padCode = (length: number, number: any, prefix = ``) => prefix + number.toString().padStart(length, '0')

/**
 * 1258291 -> "1.2 MB" ใช้ฐาน 1024 ให้ตรงกับขนาดที่ OS แสดง
 * รับ string ได้เพราะ fileSize ที่ backend ส่งมาเป็น string
 */
export const formatFileSize = (bytes?: number | string | null): string => {
  const size = Number(bytes);
  if (!isFinite(size) || size < 0) return "-";
  if (size < 1024) return `${size} B`;

  const units = ["KB", "MB", "GB"];
  let value = size / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  // Number() ตัด .0 ทิ้ง -> "1 MB" ไม่ใช่ "1.0 MB"
  return `${Number(value.toFixed(1))} ${units[unitIndex]}`;
};
